export default __webpack_public_path__ + "static/media/Vector11.76654836.svg";